import { Inject } from '@angular/core';
import { Component } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';import { FormioLoader } from 'dp-formio';

declare var $: any;
@Component({
	selector: 'add-edit-event-item',
	templateUrl: 'add-edit-event-item.component.html',
	styleUrls: ['./add-edit-event-item.component.scss'],
})
export class AddEditEventItem {

	constructor(public dialogRef: MatDialogRef<AddEditEventItem>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private loader: FormioLoader) {
	}
	ngOnInit(): void {
		this.loader.loading = false;
	}

	customEvent(event: any) {
		if (event.type == 'customCancel') this.dialogRef.close();
	}

	beforeSubmit(event: any) {
		this.dialogRef.close(event.data);
	}

	onFormLoad() {
		try {
			setTimeout(() => {
				const button = $('#cancel');
				if (!button) {
					this.onFormLoad();
					return;
				}
				setTimeout(() => button.prop('disabled', false), 500);
			}, 350);
		} catch (e) { }
	}
}
